<template>
  <el-row>
    <el-col class="column-container">
      <div class="label-container">
        <div class="field-container">
          <label class="form-label">
            {{ title }}
          </label>
          <form-item-i-tooltip placement="top-start">
            <template #content>
              <span>
                {{ tooltip }}
              </span>
            </template>
          </form-item-i-tooltip>
        </div>
        <p class="description">
          {{ description }}
        </p>
      </div>
      <div class="field-container">
        <rest-form-item style="display: flex;" :prop="prop">
          <el-switch :disabled="disabled" v-model="model[prop]" :prop="prop" />
          <form-item-i-tooltip v-if="disabled" placement="top-start">
            <template #content>
              <span>
                {{ $t('CampaignReport_Disabled_Input_Tooltip') }}
              </span>
            </template>
          </form-item-i-tooltip>
        </rest-form-item>
      </div>
    </el-col>
  </el-row>
</template>
<script>
import RestFormItem from '@/common/components/rest/RestFormItem.vue'
import FormItemITooltip from '@/common/components/form/FormItemITooltip.vue'

export default {
  name: 'ReportSwitch',

  components: { FormItemITooltip, RestFormItem },

  props: {
    model: {
      type: Object,
      required: true
    },
    prop: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    tooltip: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>
<style scoped>
.column-container {
  display: flex;
  column-gap: 41px;
  margin-bottom: 32px;
}
.label-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 300px;
}
.field-container {
  display: flex;
  align-items: center;
  margin-top: 6px;
}
.field-container div {
  margin-bottom: 5px;
}
.description {
  color: #7e8596;
  font-size: 12px;
  line-height: 18px;
}
.form-label {
  color: #5c6374;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/report/ReportSwitch.vue